export default __webpack_public_path__ + "static/media/benefit_11@3x.e9665dc5.png";